var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"px-lg-10",attrs:{"fluid":""}},[(_vm.session.type === 'video')?_c('div',[_c('SessionVideo')],1):_c('SessionRemoteDesktop')],1)}
var staticRenderFns = []

export { render, staticRenderFns }